export default "__VITE_ASSET__BZ6hQ2t0__"